import styled, { css } from 'styled-components';
import { mq, getSpace, gridContainer, setGridColumns, px2rem } from '../../../stylesheets/tools';

const StyledLogoWall = styled.div`
  padding: ${getSpace('l')} 0;

  ${mq('m')} {
    padding: ${getSpace('xxl')} 0;
  }

  ${props =>
    props.logos.length === 1 &&
    css`
      .logo-wall__grid {
        ${setGridColumns('1fr', 1)};
      }
    `}

  ${props =>
    props.logos.length === 2 &&
    css`
      .logo-wall__grid {
        ${setGridColumns('1fr', 2)};
      }
    `}

  ${props =>
    (props.logos.length === 3 || props.logos.length === 5 || props.logos.length === 6) &&
    css`
      .logo-wall__grid {
        ${setGridColumns('1fr', 2, {
          m: ['1fr', 3]
        })}
      }
    `}
  
  ${props =>
    props.logos.length !== 1 &&
    props.logos.length !== 2 &&
    props.logos.length !== 3 &&
    props.logos.length !== 5 &&
    props.logos.length !== 6 &&
    css`
      .logo-wall__grid {
        ${setGridColumns('1fr', 2, {
          m: ['1fr', 3],
          l: ['1fr', 4]
        })}
      }
    `}

  .logo-wall__grid {
    ${gridContainer()}
    gap: ${px2rem('20px')};

    ${mq('m')} {
      gap: ${px2rem('80px')};
    }
  }

  .logo-wall__logo {
    max-width: 320px;
    margin: auto;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }
`;

export default StyledLogoWall;
